export default __webpack_public_path__ + "static/media/touch pads - inactive.748c6933.svg";